import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    WeatherPageId: 1179,
    WeatherModules: null,
  },
  getters: {
    getWeatherHtml: (state) => {
      if (state.WeatherModules) {
        // concatenate all the html values for each cms module on the page.
        return state.WeatherModules.modules.map((m) => m.moduleSettings[0].value).join('');
      }
    },
  },
  mutations: {
    setWeatherModules(state, data) {
      state.WeatherModules = data;
    },
  },
  actions: {
    fetchWeather({
      commit, state, dispatch, getters, rootGetters,
    }) {
      // fetch the cms modules for the booking conditions page by id.
      const path = rootGetters['applinks/getLink']('page', state.WeatherPageId).url;
      axios.get(`/cms/pages/modules/bypath?path=${path}`)
        .then((res) => {
          commit('setWeatherModules', res.data);
        });
    },
  },
};
